<template>
  <v-container>
    <report
      title="Goal Report"
      :filter="filter"
      :team="team"
      :manager="manager"
      :user="user"
      v-on:refreshData="refreshData"
      v-on:rowClick="rowClick"
      :headers="headers"
      :loading="list_loading"
      :items="items"
      :show-table="!filter.userId"
    >
      <v-card-text class="py-0">
        <loading-spinner v-if="trend_loading"> </loading-spinner>
        <template v-else>
          <trend-chart
            :loading="trend_loading"
            :height="250"
            y-axes-fluid
            show-legend
            :multiple-trend-data="goal_trend_data"
            round
            count
            tooltipAppend=" goals"
          ></trend-chart>
          <v-row>
            <report-overall-card
              v-for="(item, i) in status_items"
              :key="i"
              :label="item.statusName"
            >
              <goal-avatar :status="item"></goal-avatar>
              <div class="caption lighttext--text mt-2">
                {{ item.distinctCount }}
                Employees
              </div>
            </report-overall-card>
          </v-row>
        </template>
        <v-tabs v-model="tab" v-if="!filter.userId">
          <v-tab :class="{ 'd-none': filter.managerId }">
            Departments
          </v-tab>
          <v-tab
            :class="{
              'd-none':
                filter.managerId ||
                (goal.overview && goal.overview.hideManagers)
            }"
          >
            Teams
          </v-tab>
          <v-tab>
            Members
          </v-tab>
        </v-tabs>
      </v-card-text>
    </report>
    <goals
      v-if="filter.userId"
      :user="user"
      ref="goals"
      v-on:save="getTrend"
      :filter="filter"
      :edit-ids="[filter.userId]"
    ></goals>
  </v-container>
</template>

<script>
import goalStatusTypes from "@/helpers/mixins/goalStatusTypes";
import { mapGetters } from "vuex";
import TrendChart from "@/components/reporting/TrendChart";
import GoalAvatar from "@/components/goals/GoalAvatar";
import ReportOverallCard from "@/components/reporting/ReportOverallCard";
import Goals from "@/components/goals/Goals";
import reports from "@/helpers/mixins/reports";
import Report from "@/components/reporting/Report";
export default {
  name: "GoalReport",
  props: {
    filter: { type: Object },
    team: { type: Object },
    manager: { type: Object },
    user: { type: Object }
  },
  components: {
    TrendChart,
    GoalAvatar,
    ReportOverallCard,
    Goals,
    Report
  },
  mixins: [reports, goalStatusTypes],
  data: () => ({
    list_loading: false,
    trend_loading: false,
    tab: 0,
    headers: [
      { text: "Name", value: "name" },
      { text: "Completed", value: "completed" },
      { text: "On-Track", value: "onTrack" },
      { text: "Off-Track", value: "offTrack" },
      { text: "Paused", value: "paused" },
      { text: "Action", value: "action" }
    ]
  }),
  watch: {
    tab(val, oldVal) {
      if (val != oldVal) {
        this.getList();
      }
    },
    filter(val, oldVal) {
      if (!oldVal && val != null) {
        this.update();
      }
    }
  },
  computed: {
    status_items() {
      return this.sortGoalStatuses(this.goal.statusItems);
    },
    items() {
      let data = [];
      switch (this.tab) {
        case 0:
          data = this.goal.teams;
          break;
        case 1:
          data = this.goal.managers;
          break;
        case 2:
          data = this.goal.members;
          break;
      }
      if (this.filter.userId) {
        data = this.goal.member;
      }
      return data || [];
    },
    goal_trend_data() {
      return this.goal_trends.map(x => ({
        label: x.name,
        color: goalStatusTypes.getColor(x.id),
        trend: x.items
      }));
    },
    ...mapGetters({
      goal: "reporting/goal",
      goal_trends: "reporting/goal_trends"
    })
  },
  created() {
    if (this.filter != null) {
      this.update();
    }
  },
  methods: {
    rowClick(item) {
      let link = this.getLink(item);
      if (!link) {
        return;
      }
      this.$router.push({ path: link });
    },
    update() {
      this.refreshData();
    },
    getList() {
      this.list_loading = true;
      Promise.all([this.$store.dispatch(this.getAction(), this.filter)])
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading report."
          );
        })
        .finally(() => {
          this.list_loading = false;
          if (this.filter.userId) {
            this.$refs.goals.redrawMasonry();
          }
        });
    },
    getTrend() {
      this.trend_loading = true;
      Promise.all([
        this.$store.dispatch("reporting/getGoalReportTrend", this.filter),
        this.$store.dispatch("reporting/getGoalReport", this.filter)
      ])
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading report."
          );
        })
        .finally(() => {
          this.trend_loading = false;
        });
    },
    getAction() {
      if (this.filter.userId) {
        return "goal/getGoals";
      }
      switch (this.tab) {
        case 0:
          return "reporting/getGoalReportTeams";
        case 1:
          return "reporting/getGoalReportManagers";
        default:
          return "reporting/getGoalReportMembers";
      }
    },
    refreshData() {
      this.$store.dispatch("reporting/clearGoalReport").then(() => {
        this.list_loading = true;
        this.trend_loading = true;
        Promise.all([
          this.$store.dispatch("reporting/getGoalReportTrend", this.filter),
          this.$store.dispatch("reporting/getGoalReport", this.filter)
        ])
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occured while loading report."
            );
          })
          .finally(() => {
            this.list_loading = false;
            this.trend_loading = false;
            if (this.filter.userId) {
              this.$refs.goals.redrawMasonry();
            }
          })
          .then(() => {
            let newTab = this.getInitialTab(this.goal.overview);
            if (newTab) {
              this.tab = newTab;
            }
            this.getList();
          });
      });
    }
  }
};
</script>
